module.exports = __webpack_public_path__ + "media/images/google-ca2f7db280e9c773e341589a81c15082.png";